module.exports = __webpack_public_path__ + "img/home-page-header-phones.fb01760a.png";